import React, { Suspense } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router';

import { LogoLoading } from "../../components/Loading";
import Sidebar from '../../components/Sidebar';

// page imports
const Dashboard = React.lazy(() => import('../../pages/Admin/Dashboard'));
const Users = React.lazy(() => import('../../pages/Admin/Users'));
const UserDetail = React.lazy(() => import('../../pages/Admin/UserDetail'));
const UploadBilling = React.lazy(() => import('../../pages/Admin/UploadBilling'));
const UpdateBilling = React.lazy(() => import('../../pages/Admin/UpdateBilling'));
const BillingListing = React.lazy(() => import('../../pages/Admin/BillingListing'));
const CaseDetail = React.lazy(() => import('../../pages/Admin/CaseDetail'));
const ContactListing = React.lazy(() => import('../../pages/Admin/ContactListing'));
const Support = React.lazy(() => import('../../pages/SupportListing/Listing'));
const SupportDetail = React.lazy(() => import('../../pages/SupportDetail'));
// const UploadCourse = React.lazy(() => import('../../pages/Admin/UploadCourses'));
// const CoursesListingOld = React.lazy(() => import('../../pages/Admin/CoursesListing'));
const Courses = React.lazy(() => import('../../pages/Admin/Courses'));
const CourseDetail = React.lazy(() => import('../../pages/Admin/CourseDetail'));
const ClinicDetail = React.lazy(() => import('../../pages/Doctor/ClinicDetail'));
const BillingMethodDetail = React.lazy(() => import('../../pages/Doctor/BillingMethodDetail'));
const Cases = React.lazy(() => import('../../pages/Admin/Cases'));
const CephAnalysis = React.lazy(() => import('../../pages/Admin/CephAnalysis'));
const CephAnalysisDetail = React.lazy(() => import('../../pages/Admin/CephAnalysisDetail'));
const Deliveries = React.lazy(() => import('../../pages/Doctor/Deliveries'));
const Indexes = React.lazy(() => import('../../pages/Admin/Indexes'));
const CreateIndex = React.lazy(() => import('../../pages/Admin/CreateIndex'));
const IndexDetail = React.lazy(() => import('../../pages/Admin/IndexDetail'));
const DatasetBuilder = React.lazy(() => import('../../pages/Admin/DatasetBuilder'));

const AdminCaseStudies = React.lazy(() => import('../../pages/Admin/CaseStudies'));
const AdminCaseStudyCreate = React.lazy(() => import('../../pages/Admin/CaseStudies/Create'));
const AdminCaseStudyUpdate = React.lazy(() => import('../../pages/Admin/CaseStudies/Update'));

const Profile = React.lazy(() => import('../../pages/Account'));
const SubDoctorDetail = React.lazy(() => import('../../pages/Doctor/UserDetail'));

// page imports


function AdminRoutes(props) {
  const location = useLocation();
  return (
    <>
      <Sidebar />
        <Suspense fallback={<LogoLoading />}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/users" element={<Users />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/ceph-analysis" element={<CephAnalysis />} />
            <Route path="/ceph-analysis/:id" element={<CephAnalysisDetail />} />
            {/* this all is in user detail */}
            <Route path="/users/:id" element={<UserDetail />} />
            <Route path="/users/:id/subdoctor" element={<SubDoctorDetail />} />
            <Route path="/invoices" element={<BillingListing />} />
            <Route path="/invoices/add" element={<UploadBilling />} />
            <Route path="/invoices/:id/update" element={<UpdateBilling />} />
            {/* <Route path="/billing/:id" element={<BillingListing />} /> */}
            <Route path="/cases/:case_id" element={<CaseDetail />} />
            <Route path="/contact-forms" element={<ContactListing />} />
            <Route path="/support" element={<Support />} />
            <Route path="/support/:id" element={<SupportDetail />} />
            {/* <Route path="/upload-course" element={<UploadCourse />} /> */}
            {/* <Route path="/courses" element={<CoursesListing />} /> */}
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" key={location.key} element={<CourseDetail />} />
            <Route path="/users/:user_id/clinics/:id" element={<ClinicDetail />} />
            <Route path="/users/:user_id/billing-methods/:id" element={<BillingMethodDetail />} />
            <Route path="/deliveries" element={<Deliveries />} />
            <Route path="/ai" element={<Indexes />} />
            <Route path="/ai/new" element={<CreateIndex />} />
            <Route path="/ai/:id" element={<IndexDetail />} />
            <Route path="/dataset-builder" element={<DatasetBuilder />} />

            <Route path="/case-studies" element={<AdminCaseStudies />} />
            <Route path="/case-studies/create" element={<AdminCaseStudyCreate />} />
            <Route path="/case-studies/:id" element={<AdminCaseStudyUpdate />} />
            {/* this all is in user detail */}
            <Route path='*' element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
    </>
  )
}

export default AdminRoutes
